import { WebsiteSchemaProps, OrganizationSchemaProps } from '@/lib/types/schema'

export function generateWebsiteSchema({
  name,
  url,
  description
}: WebsiteSchemaProps) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    description,
    url,
  }
}

export function generateOrganizationSchema({
  name,
  url,
  logo,
  description,
  socialProfiles
}: OrganizationSchemaProps) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name,
    url,
    logo,
    description,
    sameAs: socialProfiles,
  }
}

export function combineSchemas(...schemas: Record<string, unknown>[]) {
  return schemas.map(schema => ({
    ...schema,
    '@context': 'https://schema.org'
  }))
}